// extracted by mini-css-extract-plugin
export default {"container":"t87RxZ2W920DDkMkl9eM","blocks":"YgiMO5yIiwwXqlsc_SJB","header":"WkCihrRDud4dsdIbH9RW"};